"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "getClient", {
  enumerable: true,
  get: function get() {
    return _getClient.getClient;
  }
});
Object.defineProperty(exports, "hivemindConstants", {
  enumerable: true,
  get: function get() {
    return _hivemindCommon.hivemindConstants;
  }
});
var _hivemindCommon = require("@godaddy/hivemind-common");
var _getClient = require("./get-client");
var _hivemindClient = _interopRequireDefault(require("./hivemind-client"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = _hivemindClient["default"];